import type { Type } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getTypes() {
	const response = await axios.get<Type[]>(`${env.apiUrl}/types`)

	return response.data
}
